export const inputClass =
  'w-full rounded-md border border-line bg-cream px-3 py-2.5 text-bark placeholder:text-bark/45 focus:border-saddle focus:outline-none focus:ring-2 focus:ring-hay/60';

export const labelClass = 'mb-1.5 block text-sm font-medium text-bark/80';
